module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.up_loading),
      expression: "up_loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "on_board",
    attrs: {
      "element-loading-text": "Uploading..."
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg_json.title))]), _vm._v(" "), _c('ol', _vm._l((_vm.msg_json.list), function(msg, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(msg))])
  })), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.upload_s_fn,
      "mul10ple": false,
      "show-file-list": false
    }
  }, [_c('inputUpload', {
    attrs: {
      "init_width": _vm.init_width,
      "words": _vm.words
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "self"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg_json.title_self))]), _vm._v(" "), _c('ol', _vm._l((_vm.msg_json.list_self), function(msg, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(msg))])
  })), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.self_intor),
      expression: "self_intor",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "Write your self-introduction here *"
    },
    domProps: {
      "value": (_vm.self_intor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.self_intor = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    class: {
      red: _vm.self_br
    }
  }, [_vm._v(_vm._s(_vm.self_nub))]), _vm._v("/1000")])]), _vm._v(" "), _c('a', {
    staticClass: "save",
    class: {
      cancel: !_vm.has_audio || _vm.self_intor === ''
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.audioSrc) ? _c('div', {
    staticClass: "audio"
  }, [_c('audio', {
    attrs: {
      "src": _vm.audioSrc,
      "controls": "",
      "autoplay": "autoplay"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow",
    on: {
      "click": function($event) {
        _vm.offShadow()
      }
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eee1aec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/onboarding/on_board.vue
// module id = 829
// module chunks = 1